import { render, staticRenderFns } from "./AddMedia.vue?vue&type=template&id=810cb24c&scoped=true&"
import script from "./AddMedia.vue?vue&type=script&lang=js&"
export * from "./AddMedia.vue?vue&type=script&lang=js&"
import style0 from "./AddMedia.vue?vue&type=style&index=0&id=810cb24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810cb24c",
  null
  
)

export default component.exports